/**
 * Finds the current shop based on the provided store details.
 * The precedence is as follows:
 * 1. Current shop
 * 2. Default shop
 * 3. Primary shop
 * 4. First shop in the list
 * @param storeDetailsList
 */
export const findCurrentShop = (storeDetailsList: any[]): any => {
  let currentShop: any;
  let defaultShop: any;
  let primaryShop: any;

  const currentShopId = localStorage.getItem('shopId');

  storeDetailsList?.forEach(sd => {
    if (currentShopId && (sd?.shopId == currentShopId || sd?.storeId == currentShopId)) {
      currentShop = sd;
    }
    if (sd?.defaultShop) {
      defaultShop = sd;
    }
    if (sd?.shopOwnership === 'PRIMARY') {
      primaryShop = sd;
    }
  });

  if (currentShop) {
    return currentShop;
  } else if (defaultShop) {
    return defaultShop;
  } else if (primaryShop) {
    return primaryShop;
  }

  return storeDetailsList?.[0];
}
